import {
  FaServer,
  FaDatabase,
  FaGlobe,
  FaShieldAlt,
  FaBuilding,
  FaGavel,
  FaFileContract,
  FaHeadset,
  FaRegNewspaper,
  FaCreditCard,
  FaChartPie
} from 'react-icons/fa';

export const platformGuarantees = [
  {
    title: 'Dedicated Infrastructure',
    icon: FaServer,
  },
  {
    title: 'Dedicated Databases',
    icon: FaDatabase,
  },
  {
    title: 'Tenant-Specific Domains',
    icon: FaGlobe,
  },
  {
    title: 'Secure & Isolated by Design',
    icon: FaShieldAlt,
  },
];

export const platformCards = [
  {
    id: 'property',
    title: 'Property Management Platform',
    description:
      'Run leasing, maintenance, and portfolio operations with a platform built for property teams.',
    coreService: 'Property Operations Dashboard',
    icon: FaBuilding,
  },
  {
    id: 'case',
    title: 'Case / Legal Management Platform',
    description:
      'Coordinate matters, documents, and communications with workflows designed for legal teams.',
    coreService: 'Case & Matter Dashboard',
    icon: FaGavel,
  },
  {
    id: 'contract',
    title: 'Contract Management Platform',
    description:
      'Track obligations, approvals, and renewals with a contract-first operating system.',
    coreService: 'Contract Lifecycle Dashboard',
    icon: FaFileContract,
  },
];

export const includedDashboards = [
  {
    title: 'Core Service Dashboard',
    description: 'Your primary operating dashboard for property, case, or contract workflows.',
    icon: FaChartPie,
  },
  {
    title: 'Helpdesk Dashboard',
    description: 'Ticketing, SLA tracking, and inbound request triage in one place.',
    icon: FaHeadset,
  },
  {
    title: 'Blog & Articles Dashboard',
    description: 'Publish knowledge, updates, and internal documentation with approvals.',
    icon: FaRegNewspaper,
  },
  {
    title: 'Payments Dashboard',
    description: 'Invoices, subscriptions, and revenue reporting with integrated checkout.',
    icon: FaCreditCard,
  },
];

export const howItWorksSteps = [
  {
    title: 'Subscribe',
    description: 'Pick a tier and platform, then confirm billing and access details.',
  },
  {
    title: 'Complete onboarding',
    description: 'Share your domain, branding, and authentication requirements.',
  },
  {
    title: 'We provision',
    description: 'We deploy your isolated infrastructure, databases, and services.',
  },
  {
    title: 'Launch your dashboard',
    description: 'Invite your team and start operating from your dedicated platform.',
  },
];
